<template>
  <div>
    <el-dialog title="Məsul şəxs" :visible.sync="showModal" width="30%" top="30vh" append-to-body
      :close-on-press-escape="false" :close-on-click-modal="false">
      <comm-users v-model="commUserId" />
      <span slot="footer" class="dialog-footer">
        <el-button  size="small" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommUsers from "../components/CommUsers.vue";
import { CommUserUpdate } from "../../services/accident";
export default {
  components: {
    CommUsers,
  },
  data() {
    return {
      showModal: false,
      item: {},
      commUserId: null,
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    edit(item) {
      this.item = item;
      this.commUserId = this.item.acidentCommUid;
      this.showModal = true;
    },
    clickSave() {
      CommUserUpdate(this.item.id, this.commUserId, this.uid).then(
        (response) => {
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0]
                  ? response.data.errors[0]
                  : "Səhv əməliyyat",
              });
            } else {
              this.$router.push('/adm/commapprove');
              this.showModal = false;
              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped>

</style>
